module.exports = __webpack_public_path__ + "img/vex-paineis.a4e3855c.png";